const appInterface = {
    callSwitchPIPInterface: function(link) {
        if (window.App && window.App.switchPIP) {
            window.App.switchPIP(encodeURIComponent(link));
        } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.switchPIP) {
            window.webkit.messageHandlers.switchPIP.postMessage(encodeURIComponent(link));
        } else {
            location.href = link;
        }
    },
    closePIPInterface: function (link) {
        if (window.App && window.App.closePIP) {
            window.App.closePIP(encodeURIComponent(link));
            return true;
        }

        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.closePIP) {
            window.webkit.messageHandlers.closePIP.postMessage(encodeURIComponent(link));
            return true;
        }
        return false;
    },
    finishPIPInterface: function () {
        if (window.App && window.App.finishPIP) {
            window.App.finishPIP();
            return true;
        }

        if (
            window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.finishPIP) {
            window.webkit.messageHandlers.finishPIP.postMessage({});
            return true;
        }
        return false;
    },
};

const gripEvents = {
    action: function (evt) {
        const action = evt.value.action;

        if (action === "like.click") {
            callLogEvent("올영라이브_플레이어_좋아요_클릭", {
                click_source: "플레이어_좋아요",
                live_name: _broadTitle,
            });
        } else if (action === "coupon.detail") {
        } else if (evt.value.action === "couponBox.click") {
            callLogEvent("올영라이브_플레이어_쿠폰_클릭", {
                click_source: "플레이어_쿠폰",
                live_name: _broadTitle,
            });
        } else if (action === "store.click") {
            callLogEvent("올영라이브_플레이어_store_클릭", {
                click_source: "플레이어_상점아이콘",
                live_name: _broadTitle,
            });
        } else if (action === "product.click") {
        } else if (action === "message.input.click") {
        } else if (action === "message.send") {
            callLogEvent("올영라이브_플레이어_댓글전송_클릭", {
                click_source: "플레이어_댓글전송",
                live_name: _broadTitle,
            });
        }
    },
    clickBack: function () {
        if(!appInterface.finishPIPInterface()){
            history.back();
        }
    },
    clickClose: function () {
        callLogEvent(_isVod ? "라이브다시보기_닫기_클릭" : "올영라이브_플레이어_닫기_클릭", {
            click_source: "플레이어_닫기",
        });

        const redirectUrl = liveCommon.getRedirectUrl();
        let replacePath = _liveShopUrl;

        if (redirectUrl) {
            redirectUrl.searchParams.set("click_source", "플레이어_닫기");
            replacePath = redirectUrl.href;
        }

        if(!appInterface.finishPIPInterface()){
            if(!appInterface.closePIPInterface(replacePath)) {
                location.replace(replacePath);

            }
        }
    },
    clickShare: function () {
        callLogEvent(_isVod ? "라이브다시보기_공유하기_클릭" : "올영라이브_플레이어_공유하기_클릭", {
            click_source: "플레이어_공유하기",
            live_name: _broadTitle,
        });

        if (typeof oyRunShareUrl === "undefined") {
            if (navigator.clipboard) {
                navigator.clipboard.writeText(_appShareUrl).then(function () {
                    liveCommon.toastMessage("URL이 복사되었습니다.");
                });
            } else {
                alert("복사에 실패했습니다. 직접 입력해주세요.");
            }

            return;
        }

        oyRunShareUrl.share(_appShareUrl);
    },
    clickProduct: function(evt) {
        liveCommon.goodsDetail(evt.value.data.productId, evt.value.data.detailUrl, _isVod ? "다시보기_스토어상품" : "본방송_라이브상품");
    },
    clickPinProduct: function(evt) {
        liveCommon.goodsDetail(evt.value.data.productId, evt.value.data.detailUrl,_isVod ? "다시보기_상품배너" : "본방송_상품배너");
    },
    clickCouponBox: function() {
        if (_couponUrl) {
            const _path = _couponUrl.startsWith("/m/") || _couponUrl.startsWith("m/") ? _baseUrl + _couponUrl.substring(2) : _couponUrl;
            const couponUrl = new URL(_path);
            couponUrl.searchParams.append("t_page", _isVod ? "라이브다시보기" : "라이브플레이어");
            couponUrl.searchParams.append("t_click", _isVod ? "다시보기_쿠폰아이콘" : "본방송_쿠폰아이콘");
            appInterface.callSwitchPIPInterface(couponUrl.href);
        }
    },
    receiveCoupon: function (evt) {
        const xhr = new XMLHttpRequest();
        const params = new URLSearchParams();
        params.append("cpnNo", evt.value.data.couponId);
        params.append('mbrHash', _mbrHash);
        params.append('appYn', _isApp ? "Y" : "N");
        xhr.open('POST',  '/m/live/broadcast/downCouponJson.do', false);
        xhr.setRequestHeader('content-type', 'application/x-www-form-urlencoded; charset=UTF-8');
        xhr.onload = () => {
            let message = "";

            if (xhr.status === 200 && xhr.responseText) {
                const data = JSON.parse(xhr.responseText);
                if (data.ret === "0" || data.ret === 0) {
                    evt.done(true);
                    return;
                }

                message = data.message;
            }
            liveCommon.toastMessage(message || '네트워크 연결 상태를 확인하고 다시 시도해주세요');
            evt.done(false);
        };
        xhr.send(params.toString());
    },
    renewProductList: function (evt) {
        if (liveCommon._productLists === null || (Date.now() - liveCommon._productListUpdateTime) < 100) {
            liveCommon._productListUpdateTime = Date.now();
            evt.done(liveCommon._productLists = liveCommon._productLists || _products);
            return;
        }

        getProductThrottleFunc(evt);
    },
    requiredLogin: function () {
        if (!_isVod && !_tempMemberCode) {
            document.querySelector('#dim_login').style.display = 'block';
            document.querySelector('#div_login').style.display = 'block';
            document.querySelector('#div_login').classList.add('on');
            return;
        }

        if (!_isVod && _tempMemberCode) {
            liveCommon.moveTempMemberBridgePage();
        }
    },
    videoEnded: function () {
        if (_isVod) {
            location.reload();
        } else {
            liveCommon.toastMessage("연결이 끊어졌습니다. 다시 접속해 주세요.", function () {
                liveCommon.destroyBroadcast();
            });
        }
    },
};

const liveCommon = {
    _productLists: null,
    _productListUpdateTime: null,
    _miniModeSize: null,
    _player: null,
    closeLogin: function () {
        document.querySelector('#dim_login').style.display = 'none';
        document.querySelector('#div_login').style.display = 'none';
        document.querySelector('#div_login').classList.remove('on');
    },
    debounce: function(cb, delay) {
        let timer;
        return function () {
            clearTimeout(timer);
            const args = arguments;
            const context = this;
            timer = setTimeout(function () {
                cb.apply(context, args);
            }, delay);
        };
    },
    initBroadcast: function () {
        if (typeof Gripcloud !== "undefined" && _requiredAdultVerify === "N" && _isNotSupportApp === "N") {
            if (!_channelId) {
                window.addEventListener("DOMContentLoaded", function () {
                    liveCommon.toastMessage("해당 방송은 현재 이용이 어렵습니다. 다양한 다른 방송을 확인해보세요.", function() {
                        liveCommon.destroyBroadcast();
                    });
                });
            } else {
                if (Number(_couponBoxCount) === 0 || _isVod) {
                    delete gripEvents.clickCouponBox;
                }

                const productsCount = _products.filter((x) => x.productId.startsWith("A") || x.productId.startsWith("B")).length;

                liveCommon._player = Gripcloud.load({
                    channelId: _channelId,
                    type: Gripcloud.TYPE.LIVE_PLAYER,
                    session: _gripSessionKey,
                    custom: {
                        playerType: _playerType === "USER" ? Gripcloud.PLAYER_TYPE.USER : Gripcloud.PLAYER_TYPE.MANAGER,
                        couponList: _couponList,
                        excludeNotification: [1, 2, 3, 4, 5, 6, 7],
                        couponBoxCount: _couponBoxCount,
                        events: gripEvents,
                        showProduct: productsCount > 0
                    }
                });
            }
        }
    },
    destroyBroadcast: function(path, isOpenBrowser) {
        let link = path || _liveShopUrl;
        if (appInterface.closePIPInterface(link)) {
            return;
        }

        if (isOpenBrowser) {
            common.app.callOpenBrowser(link);
            location.href = _liveShopUrl;
        } else {
            location.href = link;
        }
    },
    getProductListJson: function(evt) {
        const xhr = new XMLHttpRequest();
        const url = _isVod ? '/m/live/broadcast/broadcastProductsJson.do?isVod=true&resvId=' + _productResvId : '/m/live/broadcast/broadcastProductsJson.do?resvId=' + _productResvId;
        xhr.open('GET',  url, true);
        xhr.timeout = 3000;
        xhr.onload = () => {
            if (xhr.status === 200 && xhr.responseText) {
                const data = JSON.parse(xhr.responseText);
                liveCommon._productLists = data.products;
                if (evt && evt.done) {
                    evt.done(liveCommon._productLists);
                }
            } else {
                liveCommon.toastMessage('네트워크 연결 상태를 확인하고 다시 시도해주세요');
            }
        };
        xhr.ontimeout = () => {
            liveCommon.toastMessage('네트워크 연결 상태를 확인하고 다시 시도해주세요');
        };
        xhr.send();
    },
    getRedirectUrl: function() {
        const currentLocation = new URL(location.href);
        const redirectUrl = currentLocation.searchParams.get('redirectUrl');
        let urlObj = null;
        try {
            if (redirectUrl) {
                urlObj = new URL(redirectUrl);
            }
        } catch (err) {
            void 0;
        }

        return urlObj;
    },
    goodsDetail: function (goodsNo, detailUrl, t_click) {
        if (goodsNo.startsWith("A") || goodsNo.startsWith("B")) {
            const redirectUrl = liveCommon.getRedirectUrl();
            const trackingCd = _isVod ? "Live_VOD" : "Live_Player";
            const goodsUrl = new URL(_secureUrl + "goods/getGoodsDetail.do");
            goodsUrl.searchParams.append("goodsNo", goodsNo);
            goodsUrl.searchParams.append("trackingCd", redirectUrl && redirectUrl.searchParams.has("trackingCd") ? redirectUrl.searchParams.get("trackingCd") : trackingCd);
            goodsUrl.searchParams.append("t_page", _isVod ? "라이브다시보기" : "라이브플레이어");
            goodsUrl.searchParams.append("t_click", t_click || "본방송_상품배너");

            appInterface.callSwitchPIPInterface(goodsUrl.href);
        } else {
            appInterface.callSwitchPIPInterface(detailUrl);
        }
    },
    throttle: function(cb, delay) {
        let inThrottle;
        return function() {
            const args = arguments;
            const context = this;
            if (!inThrottle) {
                cb.apply(context, args);
                inThrottle = true;
                setTimeout(function () {
                    inThrottle = false
                }, delay);
            }
        };
    },
    moveAppStore: function () {
        if(!appInterface.closePIPInterface(_secureUrl + 'live/broadcast/liveupdate.do')){
            location.href = _secureUrl + 'live/broadcast/liveupdate.do';
        }
    },
    moveLoginPage: function () {
        liveCommon.closeLogin();

        let path =_mbrHash === "" ? "login/loginForm.do" : "customer/regCertification.do";
        const urlObj = new URL(_secureUrl + path);

        urlObj.searchParams.append("redirectUrl", _ogUrl);

        if(!appInterface.closePIPInterface(urlObj.href)){
            location.href = urlObj.href;
        }
    },
    resizeAdultVerifyHandler: function () {
        document.querySelector('#adult_form').style.visibility =  window.innerWidth < (liveCommon._miniModeSize || window.innerWidth) ? 'hidden' : 'visible';
    },
    resizeLiveAlertHandler: function () {
        const rect = document.querySelector('.live_alert').getBoundingClientRect();
        if (rect.top < 0 || rect.left < 0) {
            document.querySelector('.live_alert').style.visibility = 'hidden';
        } else {
            document.querySelector('.live_alert').style.visibility = 'visible';
        }
    },
    resizeLoginHandler: function () {
        const ele = document.querySelector('#div_login');

        if (!ele || !ele.classList.contains('on')) {
            return;
        }

        const nextVisibility = window.innerWidth < (liveCommon._miniModeSize || window.innerWidth) ? 'hidden' : 'visible';
        if (ele.style.visibility !== nextVisibility) {
            ele.style.visibility = nextVisibility;
        }
    },
    toastMessage: function (message, callback) {
        const liveToast = $('.live_toast');
        liveToast.find('p').html(message);
        liveToast.show();
        liveToast.css({
            transform: 'translateY(0)',
            opacity: 1
        });

        setTimeout(function () {
            liveToast.removeAttr('style');
            liveToast.hide();
            if (callback) {
                callback();
            }
        }, 3500);
    },
    // [CJOYEX-802] 임시회원 기능 제한
    moveTempMemberBridgePage: function () {
        if (_tempMemberCode && _mbrHash) {
            let path = "login/tempMemberBridge.do";
            const urlObj = new URL(_secureUrl + path);

            urlObj.searchParams.append("returnUrl", _ogUrl);

            if(!appInterface.closePIPInterface(urlObj.href)){
                location.href = urlObj.href;
            }
        }
    },
};

const getProductThrottleFunc = liveCommon.throttle(liveCommon.getProductListJson, 200);

// PIP → 전체화면 전환(재진입) 시 상품 API를 재호출하고,
// 갱신된 목록을 그립 플레이어에 push하여 열려있는 스토어 바텀시트 UI까지 갱신한다.
window.addEventListener('resize', liveCommon.debounce(function () {
    if (window.innerWidth > liveCommon._miniModeSize) {
        liveCommon.getProductListJson({
            done: function (productList) {
                if (productList && liveCommon._player && typeof liveCommon._player.set === 'function') {
                    liveCommon._player.set('renewProductList', productList);
                }
            }
        });
    }
}, 300));

liveCommon.initBroadcast();
